import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import apiProvider from '../apiProvider/api';
import apiProvider from '../apiProvider/api';
import { IMAGE_URL } from '../../src/network/apiClient'
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
const ItemsPerPage = 10; // Number of items per page


const PaymentMethodPageLayer = () => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [formErrors, setFormErrors] = useState({});


    const [formData, setFormData] = useState({
        methodName: "",
        link: "",
        status: true,
        methodImage: null,
    });
    const [currencyFormData, setCurrencyFormData] = useState({
        currencyName: "",

    });
    const [categoryData, setCategoryData] = useState([]);
    const [currency, setCurrency] = useState([]);

    const [paymentCurrencyFormData, setPaymentCurrencyFormData] = useState({
        currencyName: "" // Default selection
    });

    const handlePaymentCurencyChange = (e, ival) => {
        console.log(e, "e", ival, "ival");

        setPaymentCurrencyFormData({
            ...paymentCurrencyFormData,
            currencyName: e.target.value,
            currencyId: ival.id
        });
    };

    const handlePaymentSubmitCurrency = async (e) => {
        e.preventDefault();
        // Handle the currency selection submission
        console.log("Selected currency:", paymentCurrencyFormData);
        const response = await apiProvider.updateTransectionCurrency(paymentCurrencyFormData);
        console.log(response, 'responce');

        if (response) {
            toast(response.response.data.message)

            const backdrop = document.querySelector(".modal-backdrop");
            const modal = document.getElementById("TransectionCurrency");

            if (modal) {
                modal.classList.remove("show");
                modal.classList.remove("d-block");
                modal.setAttribute("aria-hidden", "true");
                modal.style.display = "none";
            }

            if (backdrop) {
                backdrop.remove();
            }

            document.body.classList.remove("modal-open");
            document.body.style.overflow = "auto"; // 

        }

        // You can add your API call or state management here
        // Then close the modal if needed
        // $('#TransectionCurrency').modal('hide');
    };


    const fetchData = async () => {
        try {
            const result = await apiProvider.getPaymentMethod();
            console.log(result, "result");
            if (result) {
                setCategoryData(result.response.data.data);
            }

            const resultCurrency = await apiProvider.getCurrency();
            console.log(resultCurrency, "resultCurrency");
            if (resultCurrency) {
                setCurrency(resultCurrency.response.data.data);
            }
        } catch (error) {
            console.error("Error fetching category data:", error);
        }
    };


    useEffect(() => {
        fetchData();
    }, []); // Empty dependency array means this runs once on mount

    // Function to determine category type name
    const getCategoryTypeName = (type) => {
        return type === '1' ? 'Online' : 'Offline'; // Adjust as needed based on your actual types
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleCurencyChange = (e) => {
        const { name, value } = e.target;
        setCurrencyFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        // if (e.target.files && e.target.files.length > 0) {
        //     setFormData((prev) => ({
        //         ...prev,
        //         categoryImage: e.target.files[0],
        //     }));
        // }
        const file = e.target.files[0];

        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                alert('Only JPG and PNG image formats are allowed.');
                e.target.value = ""; // Clear the input
                return;
            }

            setFormData((prev) => ({
                ...prev,
                methodImage: file,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submitted:", formData);

        const input = new FormData();
        input.append("methodName", formData.methodName);
        input.append("link", formData.link);
        input.append("status", formData.status);
        // input.append("methodImage", formData.methodImage);

        // Only append image if it's a new file (not a string path)
        if (formData.methodImage instanceof File) {
            input.append("methodImage", formData.methodImage);
        } else if (typeof formData.methodImage === 'string') {
            // If it's a string (existing image path), you might want to handle differently
            input.append("methodImagePath", formData.methodImage);
        }

        console.log(...input, "input");

        try {
            let response;
            if (isEditMode) {
                // For edit mode, include the ID and use update endpoint
                input.append("id", formData.id);
                response = await apiProvider.updatePaymentMethod(input);
            } else {
                // For create mode
                response = await apiProvider.addPaymentMethod(input);
            }

            console.log(response, "response");

            if (response) {
                // const notify = () => toast("Wow so easy!");
                // Reset form
                toast(response.response.data.message)
                setFormData({
                    methodName: "",
                    link: "",
                    status: true,
                    methodImage: null,

                });
                const input = document.getElementById("methodImage");
                if (input) input.value = "";
                // ✅ Clear previous errors if validation passes
                setFormErrors({});

                // Refresh data
                fetchData();

                // Reset edit mode
                setIsEditMode(false);
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1000)
                // Remove modal styles and backdrop manually
                const backdrop = document.querySelector(".modal-backdrop");
                const modal = document.getElementById("exampleModalEdit");

                if (modal) {
                    modal.classList.remove("show");
                    modal.classList.remove("d-block");
                    modal.setAttribute("aria-hidden", "true");
                    modal.style.display = "none";
                }

                if (backdrop) {
                    backdrop.remove();
                }

                document.body.classList.remove("modal-open");
                document.body.style.overflow = "auto"; // 
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
    };

    const handleSubmitCurrency = async (e) => {
        e.preventDefault();
        console.log("Form submitted:", currencyFormData);

        const input = new FormData();
        input.append("currencyName", currencyFormData.currencyName);

        console.log(...input, "input");

        try {
            let response;
            if (isEditMode) {
                // For edit mode, include the ID and use update endpoint
                input.append("id", currencyFormData.id);
                response = await apiProvider.updateCurrency(input);
            } else {
                // For create mode
                response = await apiProvider.addCurrency(input);
            }

            console.log(response, "response");

            if (response) {
                // const notify = () => toast("Wow so easy!");
                // Reset form
                toast(response.response.data.message)
                setCurrencyFormData({
                    currencyName: "",

                });

                // Refresh data
                fetchData();

                // Reset edit mode
                setIsEditMode(false);
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1000)
                // Remove modal styles and backdrop manually
                const backdrop = document.querySelector(".modal-backdrop");
                const modal = document.getElementById("exampleModalEditCurrency");

                if (modal) {
                    modal.classList.remove("show");
                    modal.classList.remove("d-block");
                    modal.setAttribute("aria-hidden", "true");
                    modal.style.display = "none";
                }

                if (backdrop) {
                    backdrop.remove();
                }

                document.body.classList.remove("modal-open");
                document.body.style.overflow = "auto"; // 
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
    };
    const handleEditCurrency = (category) => {
        setIsEditMode(true);
        setCurrencyFormData({
            currencyName: category.currencyName,
            id: category.id

        });
        ;
    };


    const handleDeleteCurrency = async (category) => {
        console.log(category, "ccccccccc");

        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete "${category.currencyName}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                title: 'swal-title-small',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // 👇 Call your delete API or logic here
                const result = await apiProvider.deleteCurrency(category.id);
                console.log(result, "rrrrrrrrrrrr");
                if (result) {
                    deleteCategory(category.id);
                }



            }
        });
    };


    const handleEditClick = (category) => {
        setIsEditMode(true);
        setFormData({
            id: category.id,
            methodName: category.methodName,
            link: category.link,
            status: category.status,
            methodImage: category.methodImage
        });
        ;
    };

    const handleDelete = async (category) => {
        console.log(category, "ccccccccc");

        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete "${category.methodName}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                title: 'swal-title-small',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // 👇 Call your delete API or logic here
                const result = await apiProvider.deleteCurrency(category.id);
                console.log(result, "rrrrrrrrrrrr");
                if (result) {
                    deleteCategory(category.id);
                }



            }
        });
    };

    // Example delete function (you should replace this with your actual API call)
    const deleteCategory = async (id) => {
        try {
            // await your API delete call
            console.log("Deleting Payment method with ID:", id);

            Swal.fire(
                'Deleted!',
                'Payment Method has been deleted.',
                'success'
            );
            // Refresh data
            fetchData();

            // Optionally refresh the list or update UI
        } catch (error) {
            Swal.fire(
                'Error!',
                'There was a problem deleting the payment method.',
                'error'
            );
        }
    };


    // Calculate total pages
    const totalPages = Math.ceil(categoryData.length / ItemsPerPage);

    // Get the current page's data
    const startIndex = (currentPage - 1) * ItemsPerPage;
    const endIndex = startIndex + ItemsPerPage;
    const currentData = categoryData.slice(startIndex, endIndex);


    // currency table
    const totalPagesc = Math.ceil(currency.length / ItemsPerPage);

    // Get the current page's data
    const startIndexc = (currentPage - 1) * ItemsPerPage;
    const endIndexc = startIndexc + ItemsPerPage;
    const currentDatac = currency.slice(startIndexc, endIndexc);

    // Handle page change
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleToggle = () => {
        setFormData(prev => ({
            ...prev,
            status: !prev.status
        }));
    };

    const handleTrendingToggle = async (id, status) => {
        // console.log(courseId, "courseId", isTrending, "isTrending");
        let input = {
            id,
            status
        }
        try {
            // Call your API to update the trending status
            const response = await apiProvider.updatePaymentMethodStatus(input);

            if (response && response.status) {
                // Refresh data
                fetchData();
            }

        } catch (error) {
            console.error('Error updating trending status:', error);
            // Optionally revert the UI change if API fails
        }
    };

    console.log(currency, "currencycurrency");


    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-end">
                <div>
                    <button
                        type="button"
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-right gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalEditCurrency"
                        onClick={() => {
                            setCurrencyFormData({
                                name: "",
                                // status: true,
                            });
                        }}
                    >
                        {/* <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        /> */}
                        Add Currency
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-right gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalEdit"
                        onClick={() => {
                            setFormData({
                                methodName: "",
                                link: "",
                                status: true,
                                methodImage: null,
                            });
                            const input = document.getElementById("categoryImage");
                            if (input) input.value = "";
                        }}
                    >
                        {/* <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        /> */}
                        Add Payment Method
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-right gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#TransectionCurrency"
                        onClick={() => {
                            setCurrencyFormData({
                                name: "",
                                // status: true,
                            });
                        }}
                    >
                        {/* <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        /> */}
                        Change Payment Currency
                    </button>
                </div>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Payment Method Name</th>
                                {/* <th scope="col">Link</th> */}
                                <th scope="col" className="text-center">Status</th>
                                {/* <th scope="col">Category Slug</th> */}
                                <th scope="col" >Payment Method Image</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((category, index) => (
                                <tr key={category.id}>
                                    <td>
                                        <div className="d-flex align-items-center gap-10">

                                            {index + 1}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                                    {category.methodName}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    {/* <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.link}
                                        </span>
                                    </td> */}
                                    <td className="text-center">
                                        <div className="form-switch switch-primary d-flex align-items-center justify-content-center">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={category.status || false}
                                                onChange={(e) => handleTrendingToggle(category.id, e.target.checked)}
                                            />
                                        </div>
                                    </td>
                                    {/* <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.categorySlug}
                                        </span>
                                    </td> */}
                                    <td>
                                        {/* - */}
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.methodImage ? (
                                                <img
                                                    src={IMAGE_URL + category.methodImage}
                                                    alt="Category"
                                                    className="img-thumbnail"
                                                    style={{ width: '50px', height: '50px' }}
                                                />
                                            ) : 'No Image'}
                                        </span>
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex align-items-center gap-10 justify-content-center">
                                            {/* <button
                                                type="button"
                                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                            >
                                                <Icon
                                                    icon="majesticons:eye-line"
                                                    className="icon text-xl"
                                                />
                                            </button> */}
                                            <button
                                                type="button"
                                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModalEdit"
                                                onClick={() => handleEditClick(category)}
                                            >
                                                <Icon icon="lucide:edit" className="menu-icon" />
                                            </button>
                                            <button
                                                type="button"
                                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                onClick={() => handleDelete(category)}
                                            >
                                                <Icon
                                                    icon="fluent:delete-24-regular"
                                                    className="menu-icon"
                                                />

                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                        <span>
                            Showing {startIndex + 1} to {Math.min(endIndex, categoryData.length)} of {categoryData.length} entries
                        </span>
                        <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                            {/* Previous Page Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <Icon icon="ep:d-arrow-left" />
                                </Link>
                            </li>

                            {/* Page Numbers */}
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className="page-item">
                                    <Link
                                        className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === i + 1 ? "bg-primary-600 text-white" : "bg-neutral-200 text-secondary-light"
                                            }`}
                                        to="#"
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                        {i + 1}
                                    </Link>
                                </li>
                            ))}

                            {/* Next Page Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <Icon icon="ep:d-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                )}
            </div>

            {/* add course type model */}
            <div className="modal fade" id="exampleModalEdit" aria-labelledby="exampleModalEditLabel" aria-hidden="true" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                {isEditMode ? 'Edit Payment Method' : 'Add New Payment Method'}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Payment Method Name</label>
                                        <input
                                            type="text"
                                            name="methodName"
                                            className="form-control"
                                            value={formData.methodName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Link</label>
                                        <input
                                            type="text"
                                            name="link"
                                            className="form-control"
                                            value={formData.link}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Status</label>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="statusToggle"
                                                checked={formData.status}
                                                onChange={handleToggle}
                                            />
                                            <label className="form-check-label" htmlFor="statusToggle">
                                                {formData.status ? "Active" : "Inactive"}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Image</label>
                                        <input
                                            className="form-control form-control-sm"
                                            name="methodImage"
                                            type="file"
                                            id="methodImage"
                                            accept="image/png, image/jpeg"
                                            onChange={handleFileChange}
                                            style={{ height: "45px" }}
                                        />
                                        {formErrors.methodImage && (
                                            <div className="text-danger small mt-1">{formErrors.methodImage}</div>
                                        )}
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {isEditMode && formData.methodImage ? (
                                                <img
                                                    src={IMAGE_URL + formData.methodImage}
                                                    alt="Category"
                                                    className="img-thumbnail"
                                                    style={{ width: '50px', height: '50px' }}
                                                />
                                            ) : ''}
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary text-sm">
                                            {isEditMode ? 'Update' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* add Currency model */}

            <div className="modal fade" id="exampleModalEditCurrency" aria-labelledby="exampleModalEditLabel" aria-hidden="true" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                {isEditMode ? 'Edit Currency' : 'Add New Currency'}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmitCurrency}>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Currency Name</label>
                                        <input
                                            type="text"
                                            name="currencyName"
                                            className="form-control"
                                            value={currencyFormData.currencyName}
                                            onChange={handleCurencyChange}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary text-sm">
                                            {isEditMode ? 'Update' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br></br>

                        <div className="card-body p-24">
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col">Currency </th>
                                            <th scope="col" className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentDatac.map((category, index) => (
                                            <tr key={category.id}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-10">

                                                        {index + 1}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                {category.currencyName}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex align-items-center gap-10 justify-content-center">
                                                        {/* <button
                                                type="button"
                                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                            >
                                                <Icon
                                                    icon="majesticons:eye-line"
                                                    className="icon text-xl"
                                                />
                                            </button> */}
                                                        <button
                                                            type="button"
                                                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            // data-bs-toggle="modal"
                                                            // data-bs-target="#exampleModalEditCurrency"
                                                            onClick={() => handleEditCurrency(category)}
                                                        >
                                                            <Icon icon="lucide:edit" className="menu-icon" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => handleDeleteCurrency(category)}
                                                        >
                                                            <Icon
                                                                icon="fluent:delete-24-regular"
                                                                className="menu-icon"
                                                            />

                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* Pagination */}
                            {totalPagesc > 1 && (
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                    <span>
                                        Showing {startIndex + 1} to {Math.min(endIndex, categoryData.length)} of {categoryData.length} entries
                                    </span>
                                    <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                        {/* Previous Page Button */}
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <Link
                                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                                to="#"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            >
                                                <Icon icon="ep:d-arrow-left" />
                                            </Link>
                                        </li>

                                        {/* Page Numbers */}
                                        {[...Array(totalPages)].map((_, i) => (
                                            <li key={i} className="page-item">
                                                <Link
                                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === i + 1 ? "bg-primary-600 text-white" : "bg-neutral-200 text-secondary-light"
                                                        }`}
                                                    to="#"
                                                    onClick={() => handlePageChange(i + 1)}
                                                >
                                                    {i + 1}
                                                </Link>
                                            </li>
                                        ))}

                                        {/* Next Page Button */}
                                        <li className={`page-item ${currentPage === totalPagesc ? "disabled" : ""}`}>
                                            <Link
                                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                                to="#"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            >
                                                <Icon icon="ep:d-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* add Currency model */}

            <div className="modal fade" id="TransectionCurrency" aria-labelledby="exampleModalEditLabel" aria-hidden="true" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                Select Transaction Currency
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handlePaymentSubmitCurrency}>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label mb-3">Select your preferred transaction currency:</label>

                                        {currency.map((curren) => (
                                            <div className="form-check mb-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="transactionCurrency"
                                                    id={`currency${curren.id}`}
                                                    value={curren.currencyName}
                                                    checked={paymentCurrencyFormData.currencyName === curren.currencyName}
                                                    onChange={(e) => handlePaymentCurencyChange(e, curren)}
                                                />
                                                <label className="form-check-label" htmlFor={`currency${curren.id}`}>
                                                    <strong>{curren.currencyName}</strong>
                                                    {/* <p className="text-muted small mb-0">{curren.description}</p> */}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-12 mt-4">
                                        <button type="submit" className="btn btn-primary text-sm">
                                            Confirm Currency Selection
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />

        </div>


    )
}

export default PaymentMethodPageLayer;